import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { DistrictCreditViewModel, DistrictCredit } from "./districtCredit-viewModel"

export class DistrictCreditView extends View<DistrictCreditViewModel>{
    GetViewUniqueId(): string {
        return "V-36DE3A45-0672-4EC7-B4EA-75B8D8DC2213"
    }
    loadHtml(): string {
        let element = require('./districtCredit.html').default;
        let style = require('./districtCredit.less');
        return element;
    }
    constructor() {
       super();
    }
    public set districtCredits(v: ObservableArray<DistrictCredit>) { this._districtCredits = v; } public get districtCredits(): ObservableArray<DistrictCredit> { return this._districtCredits;} private _districtCredits: ObservableArray<DistrictCredit>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loaderEachDistrictCredit(v: ServerSideDataLoader) { this._loaderEachDistrictCredit = v; } public get loaderEachDistrictCredit(): ServerSideDataLoader { return this._loaderEachDistrictCredit;} private _loaderEachDistrictCredit: ServerSideDataLoader;
    
    refresh(){
        this.dataContext.refresh();
    }
}
